import {AdditionalProperties} from 'ApplicationEntry/models/AdditionalProperties';
import * as AP from 'ApplicationEntry/models/AdditionalProperties';
import {createAction} from 'Shared/utilities/actionCreator';
import {reverseEnum} from 'Shared/utilities/enumUtility';

export enum AdditionalPropertiesActionType {
  CHANGE_REQUIREMENT_ERROR = 'additionalProperties/CHANGE_REQUIREMENT_ERROR',
  CHANGE_PREMIUM_WAIVER = 'additionalProperties/CHANGE_PREMIUM_WAIVER',
  CHANGE_STRIKER_LAYOFF = 'additionalProperties/CHANGE_STRIKER_LAYOFF',
  CHANGE_APPLICANT_OCCUPATIONAL_CLASS = 'additionalProperties/CHANGE_APPLICANT_OCCUPATIONAL_CLASS',
  CHANGE_APPLICANT_SPOUSE_OCCUPATIONAL_CLASS = 'additionalProperties/CHANGE_APPLICANT_SPOUSE_OCCUPATIONAL_CLASS',
  CHANGE_ELIMINATION_PERIOD = 'additionalProperties/CHANGE_ELIMINATION_PERIOD',
  CHANGE_BENEFIT_PERIOD = 'additionalProperties/CHANGE_BENEFIT_PERIOD',
}

export const isAdditionalPropertiesAction = (action: any): action is AdditionalPropertiesAction =>
  action.type in reverseEnum(AdditionalPropertiesActionType);

export const changeRequirementError = (requirementError: string) =>
  createAction(AdditionalPropertiesActionType.CHANGE_REQUIREMENT_ERROR, {requirementError});
export const changePremiumWaiver = (premiumWaiver: string) =>
  createAction(AdditionalPropertiesActionType.CHANGE_PREMIUM_WAIVER, {premiumWaiver});
export const changeStrikeLayOff = (strikerLayOff: string) =>
  createAction(AdditionalPropertiesActionType.CHANGE_STRIKER_LAYOFF, {strikerLayOff});
export const changeApplicantOccupationalClass = (applicantOccupationalClass: string) =>
  createAction(AdditionalPropertiesActionType.CHANGE_APPLICANT_OCCUPATIONAL_CLASS, {applicantOccupationalClass});
export const changeApplicantSpouseOccupationalClass = (applicantSpouseOccupationalClass: string) =>
  createAction(AdditionalPropertiesActionType.CHANGE_APPLICANT_SPOUSE_OCCUPATIONAL_CLASS, {
    applicantSpouseOccupationalClass,
  });
export const changeEliminationPeriod = (eliminationPeriod: string) =>
  createAction(AdditionalPropertiesActionType.CHANGE_ELIMINATION_PERIOD, {eliminationPeriod});
export const changeBenefitPeriod = (benefitPeriod: number) =>
  createAction(AdditionalPropertiesActionType.CHANGE_BENEFIT_PERIOD, {
    benefitPeriod,
  });

export type AdditionalPropertiesAction =
  | ReturnType<typeof changeRequirementError>
  | ReturnType<typeof changePremiumWaiver>
  | ReturnType<typeof changeStrikeLayOff>
  | ReturnType<typeof changeApplicantOccupationalClass>
  | ReturnType<typeof changeApplicantSpouseOccupationalClass>
  | ReturnType<typeof changeEliminationPeriod>
  | ReturnType<typeof changeBenefitPeriod>;

type AdditionalPropertiesState = AdditionalProperties;

export default (state: AdditionalPropertiesState, action: AdditionalPropertiesAction) => {
  switch (action.type) {
    case AdditionalPropertiesActionType.CHANGE_REQUIREMENT_ERROR:
      return AP.changeRequirementError(action.payload.requirementError)(state);
    case AdditionalPropertiesActionType.CHANGE_PREMIUM_WAIVER:
      return AP.changePremiumWaiver(action.payload.premiumWaiver)(state);
    case AdditionalPropertiesActionType.CHANGE_STRIKER_LAYOFF:
      return AP.changeStrikeLayOff(action.payload.strikerLayOff)(state);
    case AdditionalPropertiesActionType.CHANGE_APPLICANT_OCCUPATIONAL_CLASS:
      return AP.changeApplicantOccupationalClass(action.payload.applicantOccupationalClass)(state);
    case AdditionalPropertiesActionType.CHANGE_APPLICANT_SPOUSE_OCCUPATIONAL_CLASS:
      return AP.changeApplicantSpouseOccupationalClass(action.payload.applicantSpouseOccupationalClass)(state);
    case AdditionalPropertiesActionType.CHANGE_ELIMINATION_PERIOD:
      return AP.changeEliminationPeriod(action.payload.eliminationPeriod)(state);
    case AdditionalPropertiesActionType.CHANGE_BENEFIT_PERIOD:
      return AP.changeBenefitPeriod(action.payload.benefitPeriod)(state);
    default:
      return state;
  }
};
